"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HasteAbilityHandler = exports.HasteActorAbilityFactory = exports.HasteAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const EffectType_1 = require("../../core/effects/EffectType");
const core_2 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
class HasteAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Haste;
        this.__typeName = "Haste";
    }
}
exports.HasteAbilityArgs = HasteAbilityArgs;
let HasteActorAbilityFactory = class HasteActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Haste", "AllAllies", 0);
    }
};
HasteActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Haste")
], HasteActorAbilityFactory);
exports.HasteActorAbilityFactory = HasteActorAbilityFactory;
let HasteAbilityHandler = class HasteAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(ability.invokerId, "feet"), "OverlappingTimeCircles"));
                container.applyProjectiles({
                    sequence: sequence.pushSequence("parallel"),
                    projectiles: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                        .filter(other => other !== ability.invokerId)
                        .filter(other => container.hasEffectOfType(other, EffectType_1.EffectType.Withering))
                        .map(targetId => ({
                        creatorId: ability.invokerId,
                        targetId,
                        path: "line",
                        type: "PurpleArcaneMissle",
                        jitter: 0
                    })),
                    onProjectile: (sequence, projectile) => {
                        const wp = container.getEffectsOfType(projectile.targetId, EffectType_1.EffectType.Withering)
                            .map(eid => container.getEffect(eid))
                            .reduce((sum, next) => sum + next.args.power, 0);
                        const tm = Math.round(wp * .5);
                        container.applyBuffs({
                            sequence: sequence.pushSequence("parallel"),
                            creatorId: ability.invokerId,
                            targetId: projectile.targetId,
                            effects: [
                                {
                                    duration: Duration_1.Duration.Instant,
                                    effect: new core_2.TurnMeterIncreaseEffectArgs(tm, true)
                                },
                                {
                                    duration: Duration_1.Duration.Instant,
                                    effect: new core_2.RemoveEffectsOfTypeEffectArgs(EffectType_1.EffectType.Withering, false)
                                },
                                {
                                    duration: Duration_1.Duration.Turns(3),
                                    effect: new core_2.SlowEffectArgs(2)
                                }
                            ]
                        });
                    }
                });
            }
        });
    }
};
HasteAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Haste)
], HasteAbilityHandler);
exports.HasteAbilityHandler = HasteAbilityHandler;
